import React, { useEffect, useRef, useState } from 'react';
import { Answer, Direction, ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { OutlinedInput } from '@material-ui/core';
import './answerList.style.scss';
import AnswerCard from './card/answerCard.index';
import AnswerCardSkeleton from './card/answerCard.skeleton';
import { useHistory, useParams } from 'react-router';
import { __AnswerListProps } from './answerList.interface';
import { RoutePath } from 'data';
import { getDBPublishAnswers } from 'scripts/db';

const AnswerList: React.FC<__AnswerListProps & ConnectedProps<typeof connector>> = function (
    props: __AnswerListProps & ConnectedProps<typeof connector>,
) {
    const lang = props.lang.publishDetail.answerList;
    const { publish } = useParams<any>();
    const [answers, setAnswers] = useState<Answer[] | undefined>();
    const history = useHistory();
    const allAnswers = useRef<Answer[]>([]);

    useEffect(() => {
        if (props.goback) {
            props.setGoback();
            history.replace(RoutePath.dashboard.publishList);
        }
    }, [props.goback]);

    useEffect(() => {
        getDBPublishAnswers(Number(publish)).then((res) => {
            allAnswers.current = res;
            setAnswers(res.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()));
        });
    }, []);

    function searchHandler(e: any) {
        let newList: Answer[] | undefined;
        if (e.target.value !== '') {
            newList = allAnswers.current
                ?.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
                .filter((item) => {
                    const name = item.id.toString().toLowerCase();
                    const filter = e.target.value.toLowerCase();
                    return name.includes(filter);
                });
            setAnswers(newList);
        } else {
            setAnswers(allAnswers.current);
        }
    }

    return (
        <div className="kiosk-answer-sheet">
            <div className="search">
                <OutlinedInput
                    placeholder={lang.searchBoxPH}
                    className="search-box"
                    dir={Direction.rtl}
                    onChange={(e) => searchHandler(e)}
                    endAdornment={<i className="material-icons">search</i>}
                />
            </div>
            <div className="contents">
                {answers ? (
                    answers.length ? (
                        answers.map((item, index) => <AnswerCard data={item} key={index} />)
                    ) : (
                        <p>{lang.noAnswer}</p>
                    )
                ) : (
                    <>
                        {Array.from(Array(10).keys()).map((item, index) => (
                            <AnswerCardSkeleton key={index} />
                        ))}
                    </>
                )}
                <div className="my-grid" />
                <div className="my-grid" />
                <div className="my-grid" />
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(AnswerList);
